const getFromLocal = key => {
  if (typeof window === 'undefined') return null;
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    return null;
  }
};
export default getFromLocal;
//# sourceMappingURL=get-from-local.js.map